export default __webpack_public_path__ + "static/media/dd1.8b82c670.jpg";